<template>
    <div class="container">
        <!-- 研三学生 -->
        <div>
            <div class="title-box3">
                <el-image style="height: 30px; width: 30px; margin-top: 5px;"
                    src="../../static/image/icon.png"></el-image>
                <h2 style="width: 150px; margin-top: 0px;">研三</h2>
            </div>

            <el-row :gutter="0">
                <el-col :span="8" v-for="item in Grade3masters" :key="i">
                    <div class="infoBox">
                        <!-- 头像 -->
                        <!-- <el-avatar style="" shape="circle" :size="120" :src="item.imgurl" fit="cover"></el-avatar> -->
                        <el-image :src="item.imgurl" :fit="fits" class="avatar-box"></el-image>
                        <!-- 基础信息 -->
                        <div class="infos">
                            <p style="font-weight: bold; font-size: 18px;">{{ item.name }}</p>
                            <p style="margin-top: -5px; font-size: 15px;">{{ item.major }}</p>
                            <p style="margin-top: -5px; font-size: 15px;">{{ item.achievement}}</p>
                        </div>
                    </div>

                </el-col>
            </el-row>
        </div>
        <!-- 研二学生 -->
        <div>
            <div class="title-box3">
                <el-image style="height: 30px; width: 30px; margin-top: 5px;"
                    src="../../static/image/icon.png"></el-image>
                <h2 style="width: 150px; margin-top: 0px;">研二</h2>
            </div>

            <el-row :gutter="0">
                <el-col :span="8" v-for="item in Grade2masters" :key="i">
                    <div class="infoBox">
                        <!-- 头像 -->
                        <!-- <el-avatar style="" shape="circle" :size="120" :src="item.imgurl" fit="cover"></el-avatar> -->
                        <el-image :src="item.imgurl" :fit="fits" class="avatar-box"></el-image>
                        <!-- 基础信息 -->
                        <div class="infos">
                            <p style="font-weight: bold; font-size: 18px;">{{ item.name }}</p>
                            <p style="margin-top: -5px; font-size: 15px;">{{ item.major }}</p>
                            <p style="margin-top: -5px; font-size: 15px;">{{ item.achievement}}</p>
                        </div>
                    </div>

                </el-col>
            </el-row>
        </div>
        <!-- 研一学生 -->
        <div>
            <div class="title-box3">
                <el-image style="height: 30px; width: 30px; margin-top: 5px;"
                    src="../../static/image/icon.png"></el-image>
                <h2 style="width: 150px; margin-top: 0px;">研一</h2>
            </div>

            <el-row :gutter="0">
                <el-col :span="8" v-for="item in Grade1masters" :key="i">
                    <div class="infoBox">
                        <!-- 头像 -->
                        <!-- <el-avatar style="" shape="circle" :size="120" :src="item.imgurl" fit="cover"></el-avatar> -->
                        <el-image :src="item.imgurl" :fit="fits" class="avatar-box"></el-image>
                        <!-- 基础信息 -->
                        <div class="infos">
                            <p style="font-weight: bold; font-size: 18px;">{{ item.name }}</p>
                            <p style="margin-top: -5px; font-size: 15px;">{{ item.major }}</p>
                            <p style="margin-top: -5px; font-size: 15px;">{{ item.achievement}}</p>
                        </div>
                    </div>

                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            fits: "cover",
            squareUrl:
                "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
            Grade3masters: [
                {
                    imgurl: "static/image/students/master/王玉祥.jpg",
                    name: "王玉祥",
                    major: "少样本学习、细粒度学习",
                    achievement:'发表sci一区1篇'

                },
                {
                    imgurl: "static/image/students/master/淡玉娇.jpg",
                    name: "淡玉娇",
                    major: "图像分割",
                    achievement:'发表sci一区1篇'

                },
                {
                    imgurl: "static/image/students/master/邓星志.jpg",
                    name: "邓星志",
                    major: "知识图谱",
                    achievement:'发表sci一区1篇'

                },

                {
                    imgurl: "static/image/students/master/周勇君.jpg",
                    name: "周勇君",
                    major: "小样本图像分类",
                    achievement:'发表sci二区1篇'

                },
                {
                    imgurl: "static/image/students/master/刘阳.jpg",
                    name: "刘阳",
                    major: "长尾病害一体化识别防控",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/余娅.jpg",
                    name: "余娅",
                    major: "植物病害严重程度评估",
                    achievement:'发表sci一区1篇'

                },
                {
                    imgurl: "static/image/students/master/袁志豪.jpg",
                    name: "袁志豪",
                    major: "病害分级",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/万潇阳.jpg",
                    name: "万潇阳",
                    major: "密集目标检测",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/谢雨珊.jpg",
                    name: "谢雨珊",
                    major: "图像描述",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/陈潮杰.jpg",
                    name: "陈潮杰",
                    major: "基础视觉模型",
                    achievement:'发表sci一区2篇'

                },
                {
                    imgurl: "static/image/students/master/周泽权.jpg",
                    name: "周泽权",
                    major: "小目标检测",
                    achievement:''

                },
                                {
                    imgurl: "static/image/students/master/谢朝阳.jpg",
                    name: "谢朝阳",
                    major: "AIDD",
                    achievement:'发表sci一区1篇'

                },
            ],
            Grade2masters: [
                {
                    imgurl: "static/image/students/master/王可为.jpg",
                    name: "王可为",
                    major: "轻量化",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/杨昊.jpg",
                    name: "杨昊",
                    major: "农业知识挖掘方向",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/毛可欣.jpg",
                    name: "毛可欣",
                    major: "密集目标检测",
                    achievement:''

                },

                {
                    imgurl: "static/image/students/master/刘鸿鹏.jpg",
                    name: "刘鸿鹏",
                    major: "光谱重建",
                    achievement:''

                },

                {
                    imgurl: "static/image/students/master/顾航.jpg",
                    name: "顾航",
                    major: "知识图谱",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/肖明淦.jpg",
                    name: "肖明淦",
                    major: "知识图谱与大模型相关",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/张艺伦.jpg",
                    name: "张艺伦",
                    major: "酶功能预测",
                    achievement:''

                },

                {
                    imgurl: "static/image/students/master/杨廷玮.jpg",
                    name: "杨廷玮",
                    major: "图文一致性描述",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/秦路富.jpg",
                    name: "秦路富",
                    major: "多模态轻量化",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/周军.jpg",
                    name: "周军",
                    major: "蛋白质功能预测",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/张军.jpg",
                    name: "张军",
                    major: "蛋白质相互作用预测",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/吴南宛.jpg",
                    name: "吴南宛",
                    major: "靶标的相互运用预测",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/郑家豪.jpg",
                    name: "郑家豪",
                    major: "3D目标检测",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/赵罗浪.jpg",
                    name: "赵罗浪",
                    major: "细粒度小样本",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/王岚颖.jpg",
                    name: "王岚颖",
                    major: "视觉计数",
                    achievement:''

                },

                {
                    imgurl: "static/image/students/master/王修宁.jpg",
                    name: "王修宁",
                    major: "关系抽取结合大模型",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/吴庆龙.jpg",
                    name: "吴庆龙",
                    major: "多模态分割",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/王欢.jpg",
                    name: "王欢",
                    major: "跨域小样本目标检测",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/肖甫.jpg",
                    name: "肖甫",
                    major: "计算机基础视觉",
                    achievement:''

                },

                {
                    imgurl: "static/image/students/master/尚兴存.jpg",
                    name: "尚兴存",
                    major: "模型的轻量化",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/王囡屹.jpg",
                    name: "王囡屹",
                    major: "基础计算机视觉",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/万巧玲.jpg",
                    name: "万巧玲",
                    major: "多模态图片生成",
                    achievement:''

                },
                {
                    imgurl: "static/image/students/master/孙天一.jpg",
                    name: "孙天一",
                    major: "image caption",
                    achievement:''

                },
            ],
            Grade1masters: [
                { imgurl: "static/image/students/master/赵胜.jpg", name: "赵胜", major: "图像分割", achievement:'' },
                { imgurl: "static/image/students/master/熊启业.jpg", name: "熊启业", major: "多模态大模型决策可解释性", achievement:'' },
                { imgurl: "static/image/students/master/黄前顶.jpg", name: "黄前顶", major: "增量学习", achievement:'' },
                { imgurl: "static/image/students/master/张深奥.jpg", name: "张深奥", major: "知识图谱自动化构建", achievement:'' },
                { imgurl: "static/image/students/master/应建航.jpg", name: "应建航", major: "多模态RAG", achievement:'' },
                { imgurl: "static/image/students/master/彭凯.jpg", name: "彭凯", major: "农业视频理解与分析", achievement:'' },
                { imgurl: "static/image/students/master/李思彤.jpg", name: "李思彤", major: "跨域或域外植物表型学习", achievement:'' },
                { imgurl: "static/image/students/master/陈仕涛.jpg", name: "陈仕涛", major: "零样本学习", achievement:'' },
                { imgurl: "static/image/students/master/蔡帅.jpg", name: "蔡帅", major: "多模态图像生成", achievement:'' },
                { imgurl: "static/image/students/master/吴凯.jpg", name: "吴凯", major: "小目标检测", achievement:'' },
                { imgurl: "static/image/students/master/陈通宇.jpg", name: "陈通宇", major: "光谱方向研究", achievement:'' },
                { imgurl: "static/image/students/master/吴佳龙.jpg", name: "吴佳龙", major: "联邦学习", achievement:'' },
                { imgurl: "static/image/students/master/杨发群.jpg", name: "杨发群", major: "显微图像分析", achievement:'' },
                { imgurl: "static/image/students/master/蒋俞萱.jpg", name: "蒋俞萱", major: "RNA与小分子互作", achievement:'' },
                { imgurl: "static/image/students/master/张铭锋.jpg", name: "张铭锋", major: "智能体数据标注", achievement:'' },
                { imgurl: "static/image/students/master/彭凯凯.jpg", name: "彭凯凯", major: "无人机", achievement:'' },
                { imgurl: "static/image/students/master/何成杰.jpg", name: "何成杰", major: "表型数据分析", achievement:'' },
            ],
            
        };
    },
    mounted() {
        // 主要用于根据自己网页的内容长度来改变左边的el-aside的高度
        // 子页面加载时触发事件
        this.$emit('changeHeight1', '320%');
    },
}
</script>
<style scoped>
.container {
    margin-left: -20px;
}

.infos {
    margin-left: 12px;
    margin-top: 5px;
}

.infoBox {
    margin-top: 20px;
    display: flex;
}

.avatar-box {
    height: 130px;
    width: 130px;
    border-radius: 50%;
}

.title-box3 {
    display: flex;
    width: 100%;
    margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/MasterStudents.vue